import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import * as appConfigActions from "../../../reducers/appconfig.actions";
import {
  CommonService,
  SampleService,
  Combo2Service
} from "../../../services/index";

@Component({
  selector: "addedit-invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./stockNewtransfer.html",
})
export class stockNewtransfer implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();


  execApi : boolean = true;
  mode = "Add";
  saveEvent: any;
  ironingList: any;
  barcode: any;
  updatelist :any;
  presentationList: any;
  beltNoList: any;
  designList: any;
  totshirts: number;
  styles: any;
  // brand: any;
  // barcode_type: any = "SET WISE";
  matchColorList: any;
  samp_id: any;
  sampleType = ["INWARD", "OUTWARD"];
  typeList = ["SET WISE", "SIZE WISE"];
  styleNoList: any;
  // typeList: any;
  // styleList = ["FORMAL", "CASUAL", "CORE", "GANG", "DAMAGE"];
  styleList = [];
  varietyList = [];
  varietyList1 = [];

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    let updateData = Object.assign({}, val["data"]);
    this.saveEvent = val["data"].tabevent;
    this.updatelist = updateData;
    if ( this.mode == "View") {
      this.loadGoodsList();
    }
  }

  get params(): any[] {
    return this._params;
  }

  sample_no: any;

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";
  groupdata: any = { sample_no: "", tot_pcs: 0, tot_amt: 0 };
  isLoading: boolean = false;
  companyList$ = [];
  sampleno: any;
  collarList: any;
  partyList: any = [];
  finyearList = [];
  list: any;
  designnoList = [];
  brandList = ['EXPOSE', 'ARAZA', 'OLIVE', 'LEOBOYS', 'OTHER BRANDS', 'CONFERENCE'];
  companyList: Observable<any[]>;
  partycodeList = [];
  usagepartslist = [];
  shadeList = [];
  colorList: any = [];
  shirtList: any = [];
  itemgroupList = [];
  sampleList = [];
  itemList = [];
  matchingList: any;
  accessoriesList = [
    "BUTTON",
    "THREAD",
    "COLLAR CANVAS",
    "KAJA THREAD",
    "BUTTON THREAD",
    "PLK",
    "CLR-UP",
    "CLR-DN",
    "BND DOWN",
    "BAND UP",
    "CUFF CANVAS",
    "MAIN LABEL",
    "EXTRA LABEL",
    "WASH CARE",
    "BONE",
    "BUT PATTI",
  ];
  sample: any = {};

  @ViewChild("partycodeAuto") partycodeAuto;
  @ViewChild("partyAuto") partyAuto;
  @ViewChild("finAuto") gstAuto;

  invnoControl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  itemCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  partycomboControl: FormControl = new FormControl();
  brandControl: FormControl = new FormControl();

  groupData: any = [];
  data: any = {};
  sampledata: any = {
    sample_type: "",
  };
  groupList: any = [];
  categoryList: any;
  type: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public toasterService: ToasterService,
    private commonService: CommonService,
    private combo: Combo2Service,
    private sampService: SampleService,
    public datePipe: DatePipe
  ) {
    this.totshirts = 0;

    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

    this.partyCtrl = new FormControl("", [
      Validators.required,
      hasValidItem.bind(this),
    ]);
    this.data = this.commonService.itemMaster();
    console.log(this.data);
  }
  hotkeys(event) {
    if (this.active) {
    }
  }

  trackByIndex(index: number, value: any) {
    return index;
  }

  ngOnInit(): void {
    this.getVarietyList();
    this.getStyleList();
  }

    getVarietyList() {
      this.combo.varietyStyleCombo().then((res: any) => {
        this.varietyList = [...res.data];
        this.varietyList1 = [...res.data];
      });
    }

    getStyleList() {
      this.combo.styleMasterCombo().then((res: any) => {
        this.styleList = res.data;
      });
    }
    loadGoodsList(){
      let params = {
        update_id: this.updatelist.update_id,
      };
      this.sampService.loadGoodsList(params).then((res: any) => {

        if(res.data.length > 0){
          this.groupList = res.data;
          this.styles = res.data[0].style;
          // this.variety = res.data[0].variety;
          // this.barcode_type = res.data[0].barcode_type;
          // this.brand = res.data[0].brand;
          this.totshirts = res.data[0].totshirts;
        }
      });
    
    }
    onClickStyle(style){
      this.varietyList = this.varietyList1.filter(el => el.style == style);
      if(this.varietyList.length == 0){
        this.varietyList =  this.varietyList1;
      }
    }
  
  getdata(barcode) {
      if (barcode.length == 7) {
        if (this.execApi) {

          this.execApi = false;

          let params = {
            barcode: barcode,
          };
          this.sampService.Specialtransferbarcode(params).then((res: any) => {
            if (res.alreadyExist == true) {
              let that = this;
              that.execApi = true;
              swal("Barcode Already Scanned").then(function () {
                that.barcode = "";
              });
            } else {
              this.execApi = true;
              this.sampleList = res.data;
              let obj: any = {};
              obj.barcode = this.sampleList[0].barcode;
              obj.shirt_design_no = this.sampleList[0].design_no;
              obj.slv = this.sampleList[0].slv;
              obj.size = this.sampleList[0].size;
              obj.mrp = this.sampleList[0].mrp;
              obj.color = this.sampleList[0].color;
              obj.shade = this.sampleList[0].code;
              obj.unitid = this.sampleList[0].unitid;
              obj.mfg_date = this.sampleList[0].mfg_date;
              obj.act_mfg_date = this.sampleList[0].act_mfg_date;
              obj.design_id = this.sampleList[0].design_id;
              obj.F34 = this.sampleList[0].F34;
              obj.F36 = this.sampleList[0].F36;
              obj.F38 = this.sampleList[0].F38;
              obj.F40 = this.sampleList[0].F40;
              obj.F42 = this.sampleList[0].F42;
              obj.F44 = this.sampleList[0].F44;
              obj.F46 = this.sampleList[0].F46;
              obj.H34 = this.sampleList[0].H34;
              obj.H36 = this.sampleList[0].H36;
              obj.H38 = this.sampleList[0].H38;
              obj.H40 = this.sampleList[0].H40;
              obj.H42 = this.sampleList[0].H42;
              obj.H44 = this.sampleList[0].H44;
              obj.H46 = this.sampleList[0].H46;
              obj.DF34 = this.sampleList[0].DF34;
              obj.DF36 = this.sampleList[0].DF36;
              obj.DF38 = this.sampleList[0].DF38;
              obj.DF40 = this.sampleList[0].DF40;
              obj.DF42 = this.sampleList[0].DF42;
              obj.DF44 = this.sampleList[0].DF44;
              obj.DF46 = this.sampleList[0].DF46;
              obj.DH34 = this.sampleList[0].DH34;
              obj.DH36 = this.sampleList[0].DH36;
              obj.DH38 = this.sampleList[0].DH38;
              obj.DH40 = this.sampleList[0].DH40;
              obj.DH42 = this.sampleList[0].DH42;
              obj.DH44 = this.sampleList[0].DH44;
              obj.DH46 = this.sampleList[0].DH46;
              if (this.styles == "DAMAGE") {
                let size = 34;
                for (let i = 0; i < Object.keys(obj).length; i++) {
                  if (obj["F" + size] == 1) {
                    obj["F" + size] = "0";
                    obj["DF" + size] = "1";
                    break;
                  }
                  if (obj["H" + size] == 1) {
                    obj["H" + size] = "0";
                    obj["DH" + size] = "1";
                    break;
                  }
                  size += 2;
                }
              }
              obj.mrp = this.sampleList[0].mrp;
              obj.hsrate = this.sampleList[0].hsrate;
              obj.fsrate = this.sampleList[0].fsrate;
              obj.barcode = this.sampleList[0].barcode;
              obj.running_no = this.sampleList[0].running_no;
              obj.dc_id = this.sampleList[0].dc_id;
              obj.ref_id = this.sampleList[0].ref_id;
              obj.ref_type = this.sampleList[0].ref_type;
              obj.mrp = this.sampleList[0].mrp;
              obj.amount = this.sampleList[0].mrp;
              for (var i = 0; i < this.groupList.length; i++) {
                let barcode = this.groupList[i].barcode;
                if (barcode == obj.barcode) {
                  swal("Barcode Already Scanned");
                  this.barcode = "";
                  this.execApi = true;
                  return false;
                }
              }
              this.groupList.push(obj);
              this.totshirts += 1;
              // this.groupList["tot_shirts"] = this.totshirts; 
              var bottom = document.querySelector("#salesTbody");
              setTimeout(() => {
                bottom.scrollTop = bottom.scrollHeight;
              }, 300);
              this.barcode = "";
            }
            this.execApi = true;
          }); 
        }
      }
  }

  addfairScan() {
    let design = this.groupList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      design[i].samp_id = this.samp_id;
      if (design[i].barcode != "") {
        desList.push(design[i]);
      }
    }
    this.groupList = desList;
    this.savefairSample();
  }
  getcontents(ind) {
    this.groupList[ind].size = this.sampleList[0].size;
    this.groupList[ind].slv = this.sampleList[0].slv;
    this.groupList[ind].shirt_design_no = this.sampleList[0].shirt_design_no;
  }
  calamt(pcs, ind) {
    let temp = this.categoryList;
    this.groupList[ind].amount = this.groupList[ind].rate * pcs;
    this.groupdata.tot_pcs = 0;
    this.groupdata.tot_amt = 0;
    for (var i = 0; i < this.groupList.length; i++) {
      this.groupdata.tot_pcs += parseInt(this.groupList[i].pcs);
      this.groupdata.tot_amt += parseInt(this.groupList[i].amount);
    }
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shirt_design_no = this.groupList[ind]["shirt_design_no"],
      color = this.groupList[ind]["color"],
      shade = this.groupList[ind]["shade"],
      size = this.groupList[ind]["size"],
      slv = this.groupList[ind]["slv"],

      mrp = this.groupList[ind]["mrp"],
      rate = this.groupList[ind]["rate"],
      amount = this.groupList[ind]["amount"];

    let nxtRow = $("#row-" + ind).next("tr");

    this.groupList.push({
      sample_no: "",
      shirt_design_no: "",
      color: "",
      shade: "",
      size: "",
      slv: "",
      //            pcs: '',
      rate: "",
      mrp: "",
      amount: "",
    });
    this.groupList[ind].samp_id = this.groupList[0].samp_id;
    $("#" + this.page_id + "sample_no" + "-" + nxtInd).focus();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#" + "date").focus();
    }, 100);
  }

  onEnterKeyPressed() {
    $("#" + "sample_no-0").focus();
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    //
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }

  onkeyrightleft($event, arrow, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if ($("#" + this.page_id + fld).length > 0) {
      $("#" + this.page_id + fld).focus();
    }
  }

  filterItems(name: string, comboType: string) {
    let list: any[];
    if (comboType == "Company") {
      list = this.companyList$;
    } else if (comboType == "Party") {
    }
    name = _.escapeRegExp(name);
    return list.filter((item) => new RegExp(name, "gi").test(item.name));
  }

  onEnterdesignno(list, ind) {
    let params = {
      design_no: list.design_no,
    };

    this.sampService.designlist(params).then((res: any) => {
      this.shadeList = res;
    });
  }

  addfairSample() {
    let design = this.groupList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      design[i].samp_id = this.samp_id;
      if (design[i].sample_no != "") {
        desList.push(design[i]);
      }
    }
    this.groupList = desList;
    this.savefairSample();
  }
  resetform() {
    $("#f1").trigger("reset");
    this.groupList = [];
    this.colorList = [];
  }
  savefairSample() {
    if (
      this.groupList[0].barcode == "" ||
      this.groupList[0].amount == "" ||
      this.groupList[0].shade == "" ||
      this.groupList[0].pcs == ""
    ) {
      swal("make sure all the datas are given");
    } else {
      let params: any = Object.assign({}, this.sampledata);
      params["tabevent"] = undefined;
      params["fairList"] = JSON.stringify(this.groupList);
      params["mode"] = this.mode;
      params["style"] = this.styles;
      // params["variety"] = this.variety;
      // params["barcode_type"] = this.barcode_type;
      // params["brand"] = this.brand;
      params["tot_shirts"] = this.totshirts;

      let that = this;
      that.isLoading = true;

      swal({
        title: "Are you sure to save this Stock?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(
        function () {
          that.isLoading = true;
          that.sampService
            .savestocktransfernew(params)
            .then(function (res: any) {
              // $( "#styleLists" ).focus();
              that.isLoading = false;
              if (that.saveEvent) {
                that.saveEvent.emit();
              }

              if (res.success) {
                that.totshirts = 0;
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });

                that.store.dispatch(new appConfigActions.SetLoadInvoice(true));
                that.styles = "";
                // that.variety = "";
                // that.brand = "";
                that.resetform();
              }
              let tabObj = {
                action: "CloseTab",
                params: {},
              };

              that.tabUpdateEvent.emit(tabObj);
            })
            .catch(function (error: any) {
              that.isLoading = false;
              let res = JSON.parse(error._body);
              swal("ERROR", res.message, "error");
            });
        },
        function (dismiss) {}
      );
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/stockNewtransfer.ts